import { Skeleton, Stack, Typography } from '@mui/material';
import { RecipeCustomerShare } from 'common/src/api/models/recipe-customer-share.models';
import { CfDataGridTableViewDefinitions } from '../../../../cf-ui/DataGrid/CfDataGridProps';

export const locationsTableView = (): CfDataGridTableViewDefinitions<RecipeCustomerShare> => {
  return {
    xs: {
      showHeader: false,
      bodyTableRowProps: () => ({
        sx: {
          alignItems: 'center',
          '&:hover': { backgroundColor: '#f5f5f5' },
        },
      }),

      columns: [
        {
          title: '',
          width: '100%',
          value: function LocationName(props) {
            return (
              <Stack>
                <Typography variant='h4' textAlign='left'>
                  {props.item.SharedWithCustomerName}
                </Typography>
                <Typography variant='responsiveParagraph'>
                  {props.item.SharedWithCustomerAddress} {props.item.SharedWithCustomerLocation}{' '}
                  {props.item.SharedWithCustomerZip}
                </Typography>
                <Typography variant='responsiveParagraph'>
                  {props.item.SharedWithCustomerOperationCompanyName} - {props.item.SharedWithCustomerNumber}
                </Typography>
              </Stack>
            );
          },
          loadingPlaceholder: (
            <Stack>
              <Skeleton width='100%' />
              <Skeleton width='100%' />
              <Skeleton width='100%' />
            </Stack>
          ),
        },
      ],
    },
    lg: {
      showHeader: false,
      bodyTableRowProps: () => ({
        sx: {
          alignItems: 'center',
          '&:hover': { backgroundColor: '#f5f5f5' },
        },
      }),

      columns: [
        {
          title: '',
          width: '65%',
          value: function LocationName(props) {
            return (
              <Stack>
                <Typography variant='h4' textAlign='left'>
                  {props.item.SharedWithCustomerName}
                </Typography>
                <Typography variant='responsiveParagraph'>
                  {props.item.SharedWithCustomerAddress} {props.item.SharedWithCustomerLocation}{' '}
                  {props.item.SharedWithCustomerZip}
                </Typography>
              </Stack>
            );
          },
          loadingPlaceholder: (
            <Stack>
              <Skeleton width='100%' />
              <Skeleton width='100%' />
            </Stack>
          ),
        },
        {
          title: '',
          width: '35%',
          value: function Description(props) {
            return (
              <Typography variant='responsiveParagraph'>
                {props.item.SharedWithCustomerOperationCompanyName} - {props.item.SharedWithCustomerNumber}
              </Typography>
            );
          },
          loadingPlaceholder: <Skeleton width='100%' />,
        },
      ],
    },
    xl: {
      showHeader: false,
      bodyTableRowProps: () => ({
        sx: {
          alignItems: 'center',
          '&:hover': { backgroundColor: '#f5f5f5' },
        },
      }),

      columns: [
        {
          title: '',
          width: '30%',
          value: function LocationName(props) {
            return (
              <Typography variant='responsiveParagraph' textAlign='left'>
                {props.item.SharedWithCustomerName}
              </Typography>
            );
          },
          loadingPlaceholder: <Skeleton width='100%' />,
        },
        {
          title: '',
          width: '35%',
          value: function Address(props) {
            return (
              <Typography variant='responsiveParagraph'>
                {props.item.SharedWithCustomerAddress} {props.item.SharedWithCustomerLocation}{' '}
                {props.item.SharedWithCustomerZip}
              </Typography>
            );
          },
          loadingPlaceholder: <Skeleton width='100%' />,
        },
        {
          title: '',
          width: '35%',
          value: function Description(props) {
            return (
              <Typography variant='responsiveParagraph'>
                {props.item.SharedWithCustomerOperationCompanyName} - {props.item.SharedWithCustomerNumber}
              </Typography>
            );
          },
          loadingPlaceholder: <Skeleton width='100%' />,
        },
      ],
    },
  };
};
